@if (link(); as routerLink) {
  <a
    class="player"
    [routerLink]="routerLink"
    [class.player--dark-text]="darkText()"
    [class.player--trailing-avatar]="trailingAvatar()"
  >
    <ng-container *ngTemplateOutlet="playerDataTemplate" />
  </a>
} @else {
  <span
    class="player"
    [class.player--unknown]="!playerDetails()?.bbUserName"
    [class.player--trailing-avatar]="trailingAvatar()"
  >
    <ng-container *ngTemplateOutlet="playerDataTemplate" />
  </span>
}

<ng-template #playerDataTemplate>
  @if (showAvatar()) {
    <lib-avatar
      class="avatar"
      [rosette]="rosette()"
      [size]="avatarSize()"
      [user]="playerDetails() || { bbUserName: '?' }"
    />
  }
  <span class="display-name">{{
    playerDetails()?.displayName ||
      playerDetails()?.bbUserName ||
      '[unknown player]'
  }}</span>
</ng-template>
